import { gsap } from 'gsap';

export function initLargeImageHero(parent) {
  const picture = parent.querySelector(
    '.large-image-hero__picture, .block-accent-media-card__picture',
  );
  const media = picture?.querySelector('img, video');
  if (!picture || !media) return;

  gsap.set(media, { opacity: 0 });

  if (media.tagName === 'VIDEO') {
    const src = (media.dataset.src || '').trim();
    if (src && media.getAttribute('src') !== src) {
      media.setAttribute('src', src);
      media.load();
    }
  }

  // Window entrance animation
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: picture,
      // markers: true,
      start: 'top bottom-=200px',
    },
  });
  tl.fromTo(
    picture,
    { opacity: 0, y: '5%', scaleX: 0.8 },
    { opacity: 1, y: 0, scaleX: 1 },
  );
  tl.fromTo(media, { opacity: 0 }, { opacity: 1 });

  if (media.tagName === 'VIDEO') {
    tl.call(() => {
      void media.play().catch(() => {});
    });
  }
}

export function initAllLargeImageHeros() {
  const blocks = document.querySelectorAll('.js-large-image-hero');
  blocks.forEach((block) => initLargeImageHero(block));
}
